export default "<p>\r\n  administracion-empresa-transporte works!\r\n</p>\r\n"